import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  * { box-sizing: border-box; }

  /* color-scheme según el tema activo: evita que el SO pinte texto negro (canvastext)
     en controles/botones cuando el dispositivo está en modo claro y la app en oscuro. */
  :root { color-scheme: ${({ theme }) => theme.name}; }

  html, body, #root { height: 100%; }

  html {
    /* Base tipográfica: todo el árbol usa rem sobre este valor (los espaciados/anchos van en px),
       así que subirla agranda la tipografía en general. 17 → 19 = +2 pt. Donde ese +2 rompía la
       estética por ancho/alto fijo (p. ej. el bottom-nav), se recorta puntualmente a ~+1. */
    font-size: 19px;
    background: ${({ theme }) => theme.colors.bg};
    color: ${({ theme }) => theme.colors.text};
    /* App vertical, sin zoom: corta el doble-tap-zoom y el pinch (refuerza el viewport meta). */
    touch-action: pan-y;
    -webkit-text-size-adjust: 100%;
    /* Pantalla fija de ancho: nada de scroll/arrastre horizontal con el dedo. Si algo se pasa unos
       px, se recorta en vez de mover toda la vista. Los carruseles internos (cards de torneos)
       mantienen su propio overflow-x + touch-action. */
    overflow-x: hidden;
  }

  body {
    margin: 0;
    font-family: system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif;
    font-size: 1rem;
    line-height: 1.45;
    background: ${({ theme }) => theme.colors.bg};
    color: ${({ theme }) => theme.colors.text};
    -webkit-font-smoothing: antialiased;
    overflow-x: hidden;
    width: 100%;
  }

  a { color: inherit; text-decoration: none; }

  /* Botones heredan el color del tema (no el canvastext del SO) → arregla texto negro. */
  button {
    font: inherit;
    color: inherit;
    cursor: pointer;
    min-height: 44px;
    -webkit-tap-highlight-color: transparent;
  }

  /* Inputs/selects también siguen el tema. */
  input, select, textarea { color: inherit; }

  @media (prefers-reduced-motion: reduce) {
    * { animation: none !important; transition: none !important; }
  }
`;
